import { http } from "../http";

export interface Translation {
  id: number;
  key: string;
  en: string;
  ar: string;
  appType: string; // 'user', 'clinician', or 'shared'
  category?: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
  createdBy?: number | null;
  updatedBy?: number | null;
}

export interface TranslationInput {
  key: string;
  en: string;
  ar: string;
  app_type: string; // 'user', 'clinician', or 'shared' - sent to API in snake_case
  category?: string;
  description?: string;
}

export interface BulkImportResult {
  created: number;
  updated: number;
  skipped: number;
  errors: Array<{ key: string; error: string }>;
}

const translationService = {
  getAll: (params?: {
    category?: string;
    search?: string;
    app_type?: string;
  }) => http.get<Translation[]>("/translations", { params }),

  getById: (id: number) => http.get<Translation>(`/translations/${id}`),

  create: (data: TranslationInput) =>
    http.post<Translation>("/translations", data),

  update: (id: number, data: Partial<TranslationInput>) =>
    http.put<Translation>(`/translations/${id}`, data),

  delete: (id: number) => http.delete(`/translations/${id}`),

  getCategories: () => http.get<string[]>("/translations/categories"),

  getLanguages: () =>
    http.get<
      Array<{
        id: number;
        code: string;
        name: string;
        native_name: string;
        is_rtl: boolean;
      }>
    >("/translations/languages"),

  exportTranslations: (language?: string) =>
    http.get<
      | Record<string, string>
      | { en: Record<string, string>; ar: Record<string, string> }
    >("/translations/export", {
      params: { language },
    }),

  getByLanguage: (language: string) =>
    http.get<Record<string, string>>(`/translations/by-language/${language}`),

  bulkImport: (
    translations: TranslationInput[],
    replaceExisting: boolean = false
  ) =>
    http.post<BulkImportResult>("/translations/bulk-import", {
      translations,
      replaceExisting,
    }),

  syncFromFlutter: (
    english: Record<string, string>,
    arabic: Record<string, string>
  ) =>
    http.post<BulkImportResult>("/translations/sync-flutter", {
      english,
      arabic,
    }),
};

export default translationService;
